module.exports = __webpack_public_path__ + "static/media/facebook.d73593ca.svg";